import { ApolloClient } from "apollo-client";
import { onError } from "apollo-link-error";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import i18next from "i18next";
import { handleGraphQLErrors, handleNetworkError } from "./Error";
import { getAuthState } from "./autStateHolder";

require("dotenv").config();

const { REACT_APP_API_URL, REACT_APP_ALLOW_LANGUAGE_SELECTION } =
  process.env || {};

const languageSelctionAllowed =
  parseInt(REACT_APP_ALLOW_LANGUAGE_SELECTION, 10) === 1 || false;

const httpLink = createHttpLink({
  uri: `${REACT_APP_API_URL}/graphql`,
});

const errorLink = onError((errorInfo) => {
  const { operation, response, graphQLErrors, networkError } = errorInfo;
  const { operationName } = operation;

  console.log(
    `ERROR: GraphQL error occurred for operation ${operationName || "(null)"}.`,
    operation,
    response,
  );

  if (graphQLErrors) {
    handleGraphQLErrors(graphQLErrors);
  }
  if (networkError) {
    handleNetworkError(networkError);
  }
});

const authLink = setContext((_, { headers }) => {
  const updatedHeaders = {
    ...headers,
    authorization: `Bearer ${getAuthState().accessToken}`,
    "accept-language": languageSelctionAllowed ? i18next.language : "en",
  };

  updatedHeaders["subscription-key"] =
    process.env.REACT_APP_APIM_SUBSCRIPTION_KEY;
  return {
    headers: updatedHeaders,
  };
});

export default new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
});
